// componentes react bootstrap
import { Form, Button, Modal, Container, Collapse } from "react-bootstrap";

// componentes
import { DropZoneFile } from "../DropZoneFile";
import Tipo from "../../combos/Tipo";
import Dependencias from "../../combos/Dependencias";
import Tematicas from "../../combos/Tematicas";
import Categoria from "../../combos/Categoria";
import SoftwareUtilizado from "../../combos/SoftwareUtilizado";
import GruposSubgrupos from "../../combos/GruposSubgrupos";
import setDatosGrupos from "../../../../services/grupos/setDatos";

// Hooks
import { useState, useEffect } from "react";
import { usePermisions } from "../../../../hooks/usePermisions";

// services
//(httt-request)
import setDatos from "../../../../services/setDatos";
import updateDatos from "../../../../services/updateDatos";

//icons
import { MdOutlineFileCopy } from "react-icons/md";

//componentes
import Alertas from "../../../common/Alertas";

// variables entorno
import { URL_IMAGE_GEOMEDELLIN } from "../../../../environment";

export default function AdminDocumento({
  caractFiltro,
  idComponente,
  show,
  onHide,
  tituloModal,
  accion,
  objectEditarDoc = null,
  buscar,
}) {
  const [rutaImg, setRutaImg] = useState(null);
  const { permissions, infoUser } = usePermisions(idComponente);

  const [fileUpload, setfileUpload] = useState(null);
  const [tipofiltroSubGruposFiltrada, setTipofiltroSubGruposFiltrada] =
    useState([]);
  const [fuenteColaborativoObject, setFuenteColaborativoObject] = useState({});

  const [dataDocumento, setDataDocumento] = useState({
    idDocumento: "",
    nombreDocumento: "",
    descripcionDocumento: "",
    categoriaDocumento: 0,
    tipoDocumento: "",
    tematicaDocumento: "",
    destacadoDocumento: false,
    dependenciaDocumento: "",
    prioridadDocumento: "",
    vinculoDocumento: "",
    activoDocumento: false,
    calificacionDocumento: false,
    colaborativo: false,
    fuenteColaborativoData: {},
    grupos: [],
    subgrupos: [],
    gestion: false,
  });

  useEffect(() => {
    if (accion === "Editar" && objectEditarDoc) {
      let datosGrupo = [];
      let datosSubGrupo = [];
      let valorRecorrer = permissions.superAdmin
        ? caractFiltro.resultGruposSubGruposSuperAdmin
        : caractFiltro.resultGruposSubGrupos;
      let idGrupoArray = objectEditarDoc.id_grupo.split(",");
      valorRecorrer.map((item) => {
        if (
          (Array.isArray(idGrupoArray) &&
            idGrupoArray.includes(item.id_grupo)) ||
          idGrupoArray === item.id_grupo
        ) {
          datosGrupo.push({ value: item.id_grupo, label: item.nombre });
        }
      });
      caractFiltro.resultSubGruposForm.map((item) => {
        if (idGrupoArray.includes(item.id_grupo)) {
          datosSubGrupo.push({ value: item.id_grupo, label: item.nombre });
        }
      });
      setFuenteColaborativoObject(
        objectEditarDoc.colaborativo
          ? {
              idColaborativo: objectEditarDoc.id_colaborativo,
              fuenteDatos: objectEditarDoc.colaborativo_fuente,
              fuenteSoftware: objectEditarDoc.colaborativo_software,
              fuenteAutor: objectEditarDoc.colaborativo_autores,
              fuenteInsEm: objectEditarDoc.colaborativo_empresa,
            }
          : {}
      );
      setDataDocumento({
        idDocumento: objectEditarDoc.id_documento,
        nombreDocumento: objectEditarDoc.nombre,
        tipoDocumento: objectEditarDoc.fk_id_tipo,
        descripcionDocumento: objectEditarDoc.descripcion,
        categoriaDocumento: objectEditarDoc.fk_id_categoria,
        tematicaDocumento: objectEditarDoc.fk_id_tematica,
        geovisor: "",
        destacadoDocumento: objectEditarDoc.destacado,
        dependenciaDocumento: objectEditarDoc.fk_id_dependencia,
        prioridadDocumento: objectEditarDoc.prioridad,
        vinculoDocumento: objectEditarDoc.vinculo,
        activoDocumento: objectEditarDoc.activo,
        calificacionDocumento: objectEditarDoc.calificable,
        colaborativo: objectEditarDoc.colaborativo,
        fuenteColaborativoData: fuenteColaborativoObject,
        grupos: datosGrupo,
        subgrupos: datosSubGrupo,
        gestion:
          objectEditarDoc.gestion === null ? false : objectEditarDoc.gestion,
      });

      setRutaImg(
        `${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Iconos/${
          objectEditarDoc.archivo?.split(".")[1]
        }.jpg`
      );
    } else {
      setDataDocumento({
        idDocumento: "",
        nombreDocumento: "",
        descripcionDocumento: "",
        categoriaDocumento: 0,
        tipoDocumento: "",
        tematicaDocumento: "",
        destacadoDocumento: false,
        dependenciaDocumento: "",
        prioridadDocumento: "",
        vinculoDocumento: "",
        activoDocumento: false,
        calificacionDocumento: false,
        colaborativo: false,
        fuenteColaborativoData: {},
        grupos: [],
        subgrupos: [],
        gestion: false,
      });

      setFuenteColaborativoObject({});
    }
  }, [objectEditarDoc, show]);

  useEffect(() => {
    setDataDocumento((prev) => ({
      ...prev,
      fuenteColaborativoData: fuenteColaborativoObject,
    }));
  }, [fuenteColaborativoObject]);

  const handleFileUpload = (file) => {
    setfileUpload(file);
  };

  const handleChange = ({ target }) => {
    setDataDocumento((prev) => ({
      ...prev,
      [target.name]: target.type === "checkbox" ? target.checked : target.value,
    }));
  };

  const handleChangePrioridad = ({ target }) => {
    if (/^-?\d*$/.test(target.value)) {
      if (target.value != "" && target.value < 1) {
        setDataDocumento((prev) => ({
          ...prev,
          [target.name]: target.type === "checkbox" ? target.checked : 100,
        }));
      } else {
        setDataDocumento((prev) => ({
          ...prev,
          [target.name]:
            target.type === "checkbox" ? target.checked : target.value,
        }));
      }
    }
  };

  const handleChangeFuenteColabo = ({ target }) => {
    setFuenteColaborativoObject((prev) => ({
      ...prev,
      [target.name]: target.value,
    }));
  };

  const handleChangeColaborativo = ({ target }) => {
    setDataDocumento((prev) => ({
      ...prev,
      [target.name]: target.checked,
      fuenteColaborativoData: !target.checked ? {} : fuenteColaborativoObject,
    }));
  };

  const handleChangeGrupos = ({ nombreCombo, valor, tipo }) => {
    if (tipo === "1") {
      let valorComparar = valor.map((val) => val.value);
      let resultSubGruposcp = caractFiltro.resultSubGruposForm.filter((item) =>
        valorComparar.includes(item.id_grupo_padre)
      );
      setTipofiltroSubGruposFiltrada(resultSubGruposcp);
      let dataDocumentocp = { ...dataDocumento };
      dataDocumentocp.subgrupos = dataDocumento.subgrupos.filter((item) =>
        valorComparar.includes(item.value_parent)
      );
      dataDocumentocp[nombreCombo] = valor;
      setDataDocumento(dataDocumentocp);
    } else {
      setDataDocumento({
        ...dataDocumento,
        [nombreCombo]: valor,
      });
    }
  };

  const saveFile = async (id) => {
    try {
      let formData = new FormData();

      formData.append("carpeta", idComponente);
      formData.append("subCarpeta", id);
      formData.append("archivos", fileUpload);

      await setDatos(`atributos/archivos`, formData);
    } catch (err) {
      throw err;
    }
  };

  const saveDoc = async (e) => {
    const {
      nombreDocumento,
      descripcionDocumento,
      dependenciaDocumento,
      tipoDocumento,
      categoriaDocumento,
      tematicaDocumento,
      colaborativo,
    } = dataDocumento;
    if (
      !nombreDocumento ||
      !descripcionDocumento ||
      !tipoDocumento ||
      !tematicaDocumento ||
      !categoriaDocumento ||
      !dependenciaDocumento
    ) {
      Alertas({
        title: "",
        html: "<span>Los campos marcados con * son obligatorios.</span>",
        icono: "warning",
      });

      return;
    }

    if (colaborativo) {
      const { fuenteDatos, fuenteSoftware, fuenteAutor, fuenteInsEm } =
        fuenteColaborativoObject;

      if (!fuenteDatos || !fuenteSoftware || !fuenteAutor || !fuenteInsEm) {
        Alertas({
          title: "",
          html: "<span>Los campos marcados con * son obligatorios.</span>",
          icono: "warning",
        });
        return;
      }
    }

    try {
      if (accion === "Editar") {
        const { data: responseIds } = await updateDatos(
          `documentacion/${dataDocumento.idDocumento}/${
            !fuenteColaborativoObject.idColaborativo
              ? ""
              : fuenteColaborativoObject.idColaborativo
          }`,
          dataDocumento
        );
        const { idDocumento } = responseIds;

        if (fileUpload) {
          await saveFile(idDocumento);
        }
        Alertas({
          title: "",
          html: "<span>Registro actualizado exitosamente.</span>",
          icono: "success",
        });
        buscar();
        guardarGruposNuevo(idDocumento);
      } else {
        const { data: responseIds } = await setDatos(
          "documentacion",
          dataDocumento
        );
        const { idDocumento } = responseIds;

        if (fileUpload) {
          await saveFile(idDocumento);
        }
        Alertas({
          title: "",
          html: "<span>Registro almacenado exitosamente.</span>",
          icono: "success",
        });
        guardarGruposNuevo(idDocumento);
      }
      onHide();
    } catch (error) {
      Alertas({
        title: "",
        html: "<span>No se pudo registrar, vuelva a intentarlo.</span>",
        icono: "warning",
      });
    }
  };

  async function guardarGruposNuevo(idModulo) {
    let gruposUnificados = dataDocumento.grupos.concat(dataDocumento.subgrupos);
    const jsonGrupos = {
      id_modulo: idModulo,
      grupos: gruposUnificados.map((val) => val.value),
      modulo: "documentos",
    };
    const respuesta = await setDatosGrupos(`geomed/grupos/agregar`, jsonGrupos);
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="md"
      id="modalAdminRegister"
      scrollable={true}
    >
      <Modal.Header closeButton>
        <Modal.Title>{tituloModal}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="pb-2">
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Nombre del documento <strong>*</strong>
              </Form.Label>
              <Form.Control
                type="text"
                className="inputs-forms-admin focus-admin-register"
                name={"nombreDocumento"}
                onChange={handleChange}
                value={dataDocumento.nombreDocumento}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Descripción <strong>*</strong>
              </Form.Label>
              <Form.Control
                as="textarea"
                className="inputs-forms-admin focus-admin-register textarea-form-admin"
                name={"descripcionDocumento"}
                onChange={handleChange}
                value={dataDocumento.descripcionDocumento}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Tipo <strong>*</strong>
              </Form.Label>
              <Tipo
                idComponente={idComponente}
                handleChange={handleChange}
                nameCombo={"tipoDocumento"}
                idTipo={dataDocumento.tipoDocumento}
              />
            </Form.Group>
            <Form.Group className="mb-4">
              <Form.Label className="label-forms-admin">
                Categoría <strong>*</strong>
              </Form.Label>
              <Categoria
                caractFiltro={caractFiltro}
                handleChange={handleChange}
                nameCombo={"categoriaDocumento"}
                idCategoria={dataDocumento.categoriaDocumento}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Temática <strong>*</strong>
              </Form.Label>
              <Tematicas
                caractFiltro={caractFiltro}
                element={idComponente}
                handleChange={handleChange}
                nameCombo={"tematicaDocumento"}
                idTematica={dataDocumento.tematicaDocumento}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">
                Dependencia <strong>*</strong>
              </Form.Label>
              <Dependencias
                handleChange={handleChange}
                nameCombo={"dependenciaDocumento"}
                idDependencia={dataDocumento.dependenciaDocumento}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">Prioridad</Form.Label>
              <Form.Control
                type={"text"}
                value={dataDocumento.prioridadDocumento}
                className="inputs-forms-admin focus-admin-register"
                name={"prioridadDocumento"}
                min={1}
                maxLength={25}
                onChange={handleChangePrioridad}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">Grupo</Form.Label>
              <GruposSubgrupos
                caractFiltro={caractFiltro}
                handleChange={handleChangeGrupos}
                nombreCombo={"grupos"}
                tipoConsulta={"1"}
                tipofiltroSubGruposFiltrada={tipofiltroSubGruposFiltrada}
                datosEditar={dataDocumento.grupos}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="label-forms-admin">Subgrupo</Form.Label>
              <GruposSubgrupos
                caractFiltro={caractFiltro}
                handleChange={handleChangeGrupos}
                nombreCombo={"subgrupos"}
                tipoConsulta={"2"}
                tipofiltroSubGruposFiltrada={tipofiltroSubGruposFiltrada}
                datosEditar={dataDocumento.subgrupos}
              />
            </Form.Group>
            <DropZoneFile
              extensiones={{
                "application/pdf": [],
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
                  [],
                "application/vnd.ms-excel": [],
                "application/msword": [".doc", ".docx"],
                "application/zip": [".7z", ".rar"],
                "application/x-zip-compressed": [".zip"],
              }}
              config={{
                icon: (
                  <MdOutlineFileCopy
                    color="#2E2E2E"
                    size={"25px"}
                    className="mb-2"
                  />
                ),
                message: "Arrastre o da clic para subir el archivo",
              }}
              tipoFile={"Archivo"}
              onNewFile={handleFileUpload}
              rutaEdit={rutaImg}
              size={100}
            />
            <Form.Group className="mb-3">
              <div className="container-checks-admin">
                <Form.Label className="label-forms-admin me-2" title="Activo">
                  Activo
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"activoDocumento"}
                  onChange={handleChange}
                  checked={dataDocumento.activoDocumento}
                />

                <Form.Label
                  className="label-forms-admin me-2"
                  title="Destacado"
                >
                  Destacado
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"destacadoDocumento"}
                  onChange={handleChange}
                  checked={dataDocumento.destacadoDocumento}
                />

                <Form.Label
                  className="label-forms-admin me-2"
                  title="Calificación"
                >
                  Calificación
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"calificacionDocumento"}
                  onChange={handleChange}
                  checked={dataDocumento.calificacionDocumento}
                />
                <Form.Label
                  className="label-forms-admin me-1"
                  title="Fuente colaborativo"
                >
                  Fuente colaborativo
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"colaborativo"}
                  onChange={handleChangeColaborativo}
                  checked={dataDocumento.colaborativo}
                />
              </div>
            </Form.Group>
            <Form.Group className="mb-3">
              <div className="container-checks-admin">
                <Form.Label
                  className="label-forms-admin me-1"
                  title="Gestión geográfica"
                >
                  Gestión geográfica
                </Form.Label>
                <Form.Check
                  type="switch"
                  className="check-geomedellin"
                  name={"gestion"}
                  onChange={handleChange}
                  checked={dataDocumento.gestion}
                />
              </div>
            </Form.Group>
            <Collapse in={dataDocumento.colaborativo}>
              <div id="example-collapse-text">
                <Form.Group className="mb-3">
                  <Form.Label className="label-forms-admin">
                    Datos abiertos utilizados / Fuente conjunto datos{" "}
                    <strong>*</strong>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="inputs-forms-admin focus-admin-register"
                    onChange={handleChangeFuenteColabo}
                    name={"fuenteDatos"}
                    value={fuenteColaborativoObject?.fuenteDatos}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="label-forms-admin">
                    Software utilizado <strong>*</strong>
                  </Form.Label>
                  <SoftwareUtilizado
                    handleChange={handleChangeFuenteColabo}
                    idSoftware={fuenteColaborativoObject?.fuenteSoftware}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="label-forms-admin">
                    Autor (es) <strong>*</strong>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="inputs-forms-admin focus-admin-register"
                    onChange={handleChangeFuenteColabo}
                    name={"fuenteAutor"}
                    value={fuenteColaborativoObject?.fuenteAutor}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label className="label-forms-admin">
                    Institución / Empresa <strong>*</strong>
                  </Form.Label>
                  <Form.Control
                    type="text"
                    className="inputs-forms-admin focus-admin-register"
                    onChange={handleChangeFuenteColabo}
                    name={"fuenteInsEm"}
                    value={fuenteColaborativoObject.fuenteInsEm}
                  />
                </Form.Group>
              </div>
            </Collapse>

            <div className="container-accion-admin-button ">
              <Button
                className="btn-geomedellin btn-register-admin btn-accion"
                onClick={saveDoc}
              >
                Guardar
              </Button>
            </div>
          </Form>
        </Container>
      </Modal.Body>
    </Modal>
  );
}
